import { useChatContext } from './ChatContext';

const useReceivedAssistantMessage = () => {
    const { isReceivedAssistantMessage, setIsReceivedAssistantMessage } = useChatContext();
    return { isReceivedAssistantMessage, setIsReceivedAssistantMessage };
};

export default useReceivedAssistantMessage;
